/** Internal */
import { gql } from "lib/apolloClient";

export const getOrganizationCoursesQuery = gql`
  query getOrganizationCourses(
    $id: ID!
    $courseFilters: CourseFilterInput
    $courseGradeFilters: CourseGradeFilters
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        courses(
          orderBy: TITLE
          orderByDirection: ASC
          filters: $courseFilters
        ) {
          edges {
            node {
              id
              title
              grades(filters: $courseGradeFilters) {
                id
                name
              }
              primaryGrade(filters: $courseGradeFilters) {
                id
                name
              }
              subjects {
                id
                name
              }
              genericTags {
                id
                label
                type
              }
              learningCourse {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;
